import type { SxProps, Theme } from '@mui/material/styles';

type PrivacySettingsStyleMap = {
    root: SxProps<Theme>
    card: SxProps<Theme>
    cardHeader: SxProps<Theme>
    headerTitle: SxProps<Theme>
    cardBody: SxProps<Theme>
    marketingSwitch: SxProps<Theme>
    saveButtonWrap: SxProps<Theme>
    gdprBody: SxProps<Theme>
    gdprLink: SxProps<Theme>
    dangerCard: SxProps<Theme>
    dangerHeader: SxProps<Theme>
    dialogTitle: SxProps<Theme>
    dialogIconWrap: SxProps<Theme>
    dialogAlert: SxProps<Theme>
    dialogActions: SxProps<Theme>
};

export const privacySettingsStyles: PrivacySettingsStyleMap = {
    root: { maxWidth: 720, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 3 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    cardHeader: { px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider' },
    headerTitle: { display: 'flex', alignItems: 'center', gap: 1 },
    cardBody: { px: 3, py: 3 },
    marketingSwitch: { alignItems: 'flex-start', ml: 0 },
    saveButtonWrap: { mt: 3 },
    gdprBody: { px: 3, py: 3, display: 'flex', flexDirection: 'column', gap: 2 },
    gdprLink: { textDecoration: 'none', '&:hover': { textDecoration: 'underline' } },
    dangerCard: { border: '1px solid', borderColor: 'error.light', borderRadius: 2, overflow: 'hidden' },
    dangerHeader: { px: 3, py: 2, bgcolor: 'error.50', borderBottom: '1px solid', borderColor: 'error.light' },
    dialogTitle: { display: 'flex', alignItems: 'center', gap: 1.5 },
    dialogIconWrap: { width: 40, height: 40, borderRadius: '50%', bgcolor: 'error.50', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
    dialogAlert: { mb: 2 },
    dialogActions: { px: 3, pb: 2 },
};

export const privacySettingsShieldColor = '#009fe3';
export const privacySettingsWarningIconColor = '#d32f2f';
